import React from 'react'
import { FloatingGroup, FloatMenuItemButton } from 'react-motion-float-button'
import { Button } from "reactstrap";
import WhatsAppAtend from '../../assets/watsapp-atend.png'
import { width } from "../../helpers/general";

const Whatsappbtn = (props) => {
    function onClick() {
        window.open(`https://api.whatsapp.com/send?phone=${process.env.REACT_APP_WHATS || '55629'}&
                    text=${process.env.REACT_WHATSAPP_MESSAGE || 'Ol%C3%A1%2C%20preciso%20de%20ajuda.'}`)
    }

    return (
        <div style={{
            margin: "10px",
            // display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // marginTop: "0px",
            zIndex: "1000px",
            border: "0.5px solid #EFEEEE",
            borderRadius: "25px",
            cursor: "pointer",
            // boxShadow: "0.2px 0.2px #17a2b8",
            // backgroundColor: "#49BCCE",
            backgroundImage:
                "linear-gradient(to top, #17a2b8, #1BBFD9 90%)",
        }}
            onClick={onClick}
            title="Entre em contato com a nossa equipe de atendimento"
        >
            <div style={{ bottom: "0", right: "0", marginTop: "15px", marginBotton: "0px", marginLeft: "10px", }} onClick={onClick}>
                <FloatMenuItemButton
                    containerStyle={{ height: "35px" }}
                    icon={<i className="mdi mdi-whatsapp" style={{ fontSize: "25px" }} />}
                    buttonColor="#25D366"
                    onClick={onClick}
                >
                </FloatMenuItemButton>
            </div>

            <div style={{ marginTop: "-25px", marginBotton: "0px", }}>
                <img
                    src={WhatsAppAtend}
                    style={{
                        width: width() !== "mobile" ? "100px" : "60px",
                        marginLeft: width() !== "mobile" ? "50px" : "5px",
                        cursor: "pointer"
                    }}
                    className="rounded-logo"
                    alt=""
                    onClick={onClick}
                />
            </div>
            <div className='text-center text-white' style={{ marginTop: "-15px" }}>
                <strong>Suporte Online</strong>
            </div>
            {/* <FloatingGroup size={process.env.WHATSAPP_SIZE} direction={process.env.WHATSAPP_TOP} spacing={100}
                rootButtonContainerStyle={{ background: "#104e5a", margin: "0" }}
                rootButtonElement={<Button className="btn-suporte"><i className="fa fa-plus" style={{ fontSize: "18px" }} /></Button>}>
                <FloatMenuItemButton
                    containerStyle={{ height: "55px" }}
                    icon={<i className="mdi mdi-whatsapp" style={{ fontSize: "38px" }} />}
                    buttonColor="#25D366"
                    onClick={e => window.open(`https://api.whatsapp.com/send?phone=${process.env.REACT_WHATSAPP_FONE || '5562982270001'}&
                    text=${process.env.WHATSAPP_MESSAGE || 'Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20o%2055Zap'}`)}
                />
                <FloatMenuItemButton
                    containerStyle={{ display: "none" }}
                    icon={<i className="mdi mdi-whatsapp" style={{ fontSize: "38px" }} />}
                    buttonColor="#4f5bd5"
                />
            </FloatingGroup> */}
        </div>
    )
}

export default Whatsappbtn